module.exports = __webpack_public_path__ + "static/media/indexWarning.f65be10.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/common/music/indexWarning.mp3
// module id = J++R
// module chunks = 101